import "../styles/Contacts.css";
import { Mail, Linkedin, Github, Phone } from "lucide-react";

const phoneNumber = "+358465508147";

function openWhatsAppWithPhoneNumber(phoneNumber: string) {
  const cleanedPhoneNumber = phoneNumber.replace(/\D/g, "");
  const whatsappURL = `https://wa.me/${cleanedPhoneNumber}`;
  window.open(whatsappURL);
}

function openLinkedIn() {
  const linkedinURL = `https://www.linkedin.com/in/vladislavpogudin/`;
  window.open(linkedinURL);
}

function openEMail() {
  const emailURL = `mailto:vladislavpogudin.dev@gmail.com`;
  window.open(emailURL);
}

function openGitHub() {
  const githubURL = `https://github.com/GudokVlad-Pilot`;
  window.open(githubURL);
}

function openFProject() {
  const fprojectURL = `https://www.instagram.com/f.project.art/`;
  window.open(fprojectURL);
}

function openGudokVladInst() {
  const gudokvladinstURL = `https://www.instagram.com/gudokvlad/`;
  window.open(gudokvladinstURL);
}

const Contacts = () => {
  const handleWhatsAppClick = () => {
    openWhatsAppWithPhoneNumber(phoneNumber);
  };

  return (
    <div className="underline">
      <div className="contacts">Contacts</div>
      <tr className="contactsTable">
        <th className="cell">
          <div className="socialMediaLink" onClick={openEMail}>
            <Mail size={32} className="mr-2" />
            <div className="socialMediaDesc">
              vladislavpogudin.dev@gmail.com
            </div>
          </div>
        </th>
        <th className="cell">
          <div className="socialMediaLink" onClick={openLinkedIn}>
            <Linkedin size={32} className="mr-2" />
            <div className="socialMediaDesc">Vladislav Pogudin</div>
          </div>
        </th>
        <th className="cell">
          <div className="socialMediaLink" onClick={handleWhatsAppClick}>
            <Phone size={32} className="mr-2" />
            <div className="socialMediaDesc">+358 46 550 81 47</div>
          </div>
        </th>
        <th className="cell">
          <div className="socialMediaLink" onClick={openGitHub}>
            <Github size={32} className="mr-2" />
            <div className="socialMediaDesc">GudokVlad-Pilot</div>
          </div>
        </th>
      </tr>
      <div className="rights">&copy; Copyright 2025. All rights reserved.</div>
      <div className="power">
        Created by&nbsp;
        <div className="powerLink" onClick={openGudokVladInst}>
          GudokVlad
        </div>
        .
      </div>
      <div className="power">
        Designed by&nbsp;
        <div className="powerLink" onClick={openFProject}>
          F.Project
        </div>
        .
      </div>
    </div>
  );
};

export default Contacts;
